import React from 'react';
import { useTranslation } from '../../hooks/useTranslation.jsx';

export default function AboutPage() {
  const { contentLanguage } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl font-black text-gray-900 mb-8">
        {contentLanguage === 'el' ? 'Σχετικά με το HAHUB' : 'About HAHUB'}
      </h1>
      
      <div className="prose prose-lg prose-blue">
        <p className="text-xl text-gray-600 leading-relaxed mb-8">
          {contentLanguage === 'el'
            ? 'Το HAHUB είναι μια πολύγλωσση πλατφόρμα γνώσης για την υποστήριξη του καρκίνου, η οποία λειτουργεί από εθελοντές και ελέγχεται από ειδικούς.'
            : 'HAHUB is a multilingual, volunteer-powered, and expert-vetted cancer support knowledge platform.'}
        </p>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            {contentLanguage === 'el' ? 'Η Αποστολή μας' : 'Our Mission'}
          </h2>
          <p className="text-gray-700">
            {contentLanguage === 'el'
              ? 'Η αποστολή μας είναι να παρέχουμε πολύτιμες, κατανοητές και αξιόπιστες πληροφορίες σε ασθενείς με καρκίνο, τις οικογένειές τους και τους φροντιστές τους.'
              : 'Our mission is to provide valuable, understandable, and trustworthy information to cancer patients, their families, and caregivers.'}
          </p>
        </section>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 my-12">
          <div className="p-6 bg-blue-50 rounded-2xl border border-blue-100">
            <h3 className="text-xl font-bold text-blue-900 mb-2">
              {contentLanguage === 'el' ? 'Αξιόπιστο' : 'Trustworthy'}
            </h3>
            <p className="text-blue-800 text-sm">
              {contentLanguage === 'el'
                ? 'Κάθε περιεχόμενο ελέγχεται προσεκτικά πριν δημοσιευτεί.'
                : 'Every piece of content is carefully reviewed before publication.'}
            </p>
          </div>
          <div className="p-6 bg-emerald-50 rounded-2xl border border-emerald-100">
            <h3 className="text-xl font-bold text-emerald-900 mb-2">
              {contentLanguage === 'el' ? 'Πολύγλωσσο' : 'Multilingual'}
            </h3>
            <p className="text-emerald-800 text-sm">
              {contentLanguage === 'el'
                ? 'Υποστηρίζουμε Ελληνικά και Αγγλικά για να βοηθήσουμε περισσότερους ανθρώπους.'
                : 'Supporting Greek and English to reach more people in need.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}